import { Component, ContentChild, AfterContentInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { List as ImmutableList } from 'immutable';
import { PiControlValueAccessor } from './OkapiControlValueAccessor.interface';

/**
 * The role of this component is to take the <ok-pillbox-with-typeahead> component
 * that exposes an array as its ngModel and convert that to a single model value
 * that can be bound to. E.g. instead of binding to Person[], you could bind to
 * Person.
 */
@Component({
    selector: 'array-to-single-model',
    template: ` <ng-content></ng-content> `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ArrayToSingleModelHigherOrderComponent,
            multi: true
        }
    ],
    standalone: false
})
export class ArrayToSingleModelHigherOrderComponent
    implements ControlValueAccessor, AfterContentInit
{
    private modelValue: any;

    @ContentChild('childComponent', { static: true })
    childComponent: PiControlValueAccessor;

    ngAfterContentInit() {
        const originalFunc = this.childComponent.propagateChange;
        this.childComponent.propagateChange = (changed) => {
            if (changed) {
                this.boundValue = changed.first();
            }
            originalFunc(changed);
        };
    }

    // Value needed by ControlValueAccessor - it is a no-op that is replaced by framework
    propagateChange: (changed: any) => void = () => {
        /* No-op required by ControlValueAccessor interface - see registerOnChange */
    };

    get boundValue(): any {
        return this.modelValue;
    }
    set boundValue(val: any) {
        this.modelValue = val;
        this.propagateChange(this.modelValue);
    }

    /* Meet ControlValueAccessor Interface */
    // Do NOT propagate changes up here
    writeValue(value: any): void {
        this.modelValue = value;

        let valueToWrite = ImmutableList();
        if (value) {
            valueToWrite = valueToWrite.push(value);
        }
        this.childComponent.writeValue(valueToWrite);
    }
    registerOnChange(fn: any): void {
        this.propagateChange = (changed: any) => fn.call(this, changed);
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    /** ***************************************/
}
